// extracted by mini-css-extract-plugin
export default {"root":"style_root__UZLQR","header":"style_header__EF48j","content":"style_content__o4Ozo"};